export type BlastChannel = 'email' | 'sms'

const basePath = (channel: BlastChannel) => (channel === 'email' ? '/email_blasts' : '/sms_blasts')

export const blastUrl = (channel: BlastChannel, id: string) => `${basePath(channel)}/${id}`

export const editBlastUrl = (channel: BlastChannel, id: string, recipients: string) =>
  `${blastUrl(channel, id)}/edit?recipients=${encodeURIComponent(recipients)}`

export const submitBlastUrl = (channel: BlastChannel, id: string) => `${blastUrl(channel, id)}/submit`

export const groupUrl = (id: string) => `/groups/${id}`
